import {
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton,
  UserButton,
  useAuth,
} from "@clerk/clerk-react";
import { SessionsPage } from "./components/SessionsPage";
import { setAuthTokenGetter } from "./api/client";

function AuthenticatedApp() {
  const { getToken, isLoaded } = useAuth();

  if (!isLoaded) {
    return (
      <p className="text-center p-8 bg-bg rounded-xl my-4">Loading...</p>
    );
  }

  setAuthTokenGetter(getToken);

  return (
    <>
      <header className="flex justify-end mb-4">
        <UserButton afterSignOutUrl="/" />
      </header>
      <SessionsPage />
    </>
  );
}

export function App() {
  return (
    <div className="max-w-4xl mx-auto p-8">
      <SignedOut>
        <div className="text-center py-16 px-8">
          <h1 className="text-5xl font-bold mb-4">🏋️ Gym Tracker</h1>
          <p className="opacity-70 mb-8 text-lg">Sign in to track your workout sessions</p>
          <div className="flex gap-4 justify-center">
            <SignInButton mode="modal">
              <button className="px-5 py-2.5 rounded-lg font-semibold bg-primary text-bg hover:bg-primary-hover transition-colors cursor-pointer">
                Sign In
              </button>
            </SignInButton>
            <SignUpButton mode="modal">
              <button className="px-5 py-2.5 rounded-lg font-semibold bg-transparent text-primary border-2 border-primary hover:bg-primary hover:text-bg transition-colors cursor-pointer">
                Sign Up
              </button>
            </SignUpButton>
          </div>
        </div>
      </SignedOut>
      <SignedIn>
        <AuthenticatedApp />
      </SignedIn>
    </div>
  );
}

export default App;
